<app-basic-card>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="currentTab" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="RICERCA">
            <app-basic-form [form]="simpleSearchForm" [keys]="simpleSearchKeys" (keydown.enter)="search()"></app-basic-form>
        </mat-tab>
        <mat-tab label="RICERCA AVANZATA">
            <app-basic-form [form]="advancedSearchForm" [keys]="advancedSearchKeys" (keydown.enter)="search()"></app-basic-form>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex justify-content-start">
        <button mat-flat-button color="primary" (click)="search()" [disabled]="searchButtonDisabled">{{'ricerca' | uppercase}}</button>
        <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
    </div>
</app-basic-card>
